import React, { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'

import {
  Box, Heading, Image, LoadingBubbles, Link, Text,
} from '@domain-group/suit-theme'

import LogoMarkUrl from './assets/logo-mark.svg'

type Auth0Payload = ReturnType<typeof useAuth0>

const renderLoginLink = (
  error: Auth0Payload['error'],
  loginWithRedirect: Auth0Payload['loginWithRedirect'],
  logout: Auth0Payload['logout']
) => {
  if (error){
    return <Link onClick={() => logout()}>Try Another Account</Link>
  }

  return (
    <Link onClick={() => loginWithRedirect({
      authorizationParams: { application: process.env.REACT_APP_APPLICATION_NAME }
    })}>
      Login
    </Link>
  )
}

const Login = () => {
  const authPayload = useAuth0()
  const {
    error, isAuthenticated, isLoading, loginWithRedirect, logout,
  } = authPayload

  useEffect(() => {
    if (!error && !isAuthenticated && !isLoading){
      loginWithRedirect({
        appState: { redirectPath: window.location.hash },
        authorizationParams: { application: process.env.REACT_APP_APPLICATION_NAME },
      })
    }
  }, [error, isAuthenticated, isLoading, loginWithRedirect])

  return (
    <Box
      alignItems="center"
      backgroundColor="whiteGrey"
      height="100vh"
      justifyContent="center"
      padding={['large', 'xxlarge']}
      width="100%"
    >
      <Box alignItems="center" flexDirection="column" justifyContent="center" width={['100%', '400px']}>
        <Image backgroundSize="contain" url={LogoMarkUrl} width={50} height={50} />

        <Heading textProps={{ color: 'bodyFontLightColor', marginTop: 'xlarge' }}>
          {error ? 'Error' : 'Loading Application...'}
        </Heading>

        {!error && <LoadingBubbles color="rgba(0, 0, 0, 0.15)" style={{ marginTop: 32 }} />}

        {error && <Text marginTop="xlarge">{error.message}</Text>}

        <Box alignItems="center" fontSize="xsmall" justifyContent="center" marginTop="xxlarge">
          <Text color="bodyFontLightColor" marginRight="small">Not Loading?</Text>
          {renderLoginLink(error, loginWithRedirect, logout)}
        </Box>
      </Box>
    </Box>
  )
}

export default Login
